// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"193":"82ffe1fa557cd73d","750":"744d4a2b58a96af7"}[chunkId] + ".js";
};